export default __webpack_public_path__ + "static/media/529.f12b3f74.png";